import getConfig from 'next/config'

const apiUrl = process.env.NEXT_PUBLIC_API_BASE_URL ?? '/api'
const API_ENDPOINT = (endpoint: string) => `${apiUrl}${endpoint}`

export const USERS_ENDPOINT = API_ENDPOINT('/users')
export const USER_FIND_ENDPOINT = (q: string, category: 'nickname' | 'email' = 'nickname') => `${USERS_ENDPOINT}/find?q=${q}&category=${category}`
export const USER_ENDPOINT = (id: string) => `${USERS_ENDPOINT}/${id}`
export const USER_PROJECTS_ENDPOINT = (user: string) => `${USER_ENDPOINT(user)}/projects`
export const USER_ARTICLES_ENDPOINT = (user: string) => `${USER_ENDPOINT(user)}/articles`
export const USER_REVIEWS_ENDPOINT = (user: string) => `${USER_ENDPOINT(user)}/reviews`
export const USER_TEMPLATES_ENDPOINT = (user: string) => `${USER_ENDPOINT(user)}/templates`
export const USER_NEWLY_REGISTERED_ENDPOINT = (id: string) => `${USER_ENDPOINT(id)}/newly-registered`
export const USER_VERIFY_ENDPOINT = (id: string) => `${USER_ENDPOINT(id)}/verify`
export const USER_RESET_PASSWORD_ENDPOINT = USERS_ENDPOINT + '/reset-password'

export const PROJECTS_ENDPOINT = API_ENDPOINT('/projects')
export const PROJECT_ENDPOINT = (id: string) => `${PROJECTS_ENDPOINT}/${id}`
export const PROJECT_FILES_ENDPOINT = (id: string) => `${PROJECT_ENDPOINT(id)}/files`
export const QUERY_PROJECT_FILES_ENDPOINT = (id: string) => `${PROJECT_ENDPOINT(id)}/files/query`
export const PROJECT_FILES_WITH_LINKED_ARTICLES_ENDPOINT = (id: string) => `${PROJECT_ENDPOINT(id)}/files/linked`
export const PROJECT_DOCUMENT_ENDPOINT = (id: string, documentId: string) => `${PROJECT_ENDPOINT(id)}/files/documents/${documentId}`
export const PROJECT_BLOB_ENDPOINT = (id: string, blobId: string) => `${PROJECT_ENDPOINT(id)}/files/blob/${blobId}`

export const JOURNALS_ENDPOINT = API_ENDPOINT('/journals')
export const JOURNALS_WITH_ARTICLE_SAMPLES_ENDPOINT = JOURNALS_ENDPOINT + '/with-article-samples'
export const JOURNAL_ENDPOINT = (id: string) => `${JOURNALS_ENDPOINT}/${id}`
export const JOURNAL_THUMBNAIL_ENDPOINT = (id: string) => `${JOURNAL_ENDPOINT(id)}/thumbnail`
// export const JOURNAL_ARTICLES_ENDPOINT = (id: string) => `${JOURNAL_ENDPOINT(id)}/articles`
export const JOURNAL_REQUESTS_ENDPOINT = (id: string) => `${JOURNAL_ENDPOINT(id)}/requests`
export const JOURNAL_TEMPLATES_ENDPOINT = (jid: string) => `${JOURNAL_ENDPOINT(jid)}/templates`
export const JOURNAL_ARTICLE_SAMPLES_ENDPOINT = (jid: string) => `${JOURNAL_ENDPOINT(jid)}/article-samples`
export const JOURNAL_ARTICLE_SAMPLE_ENDPOINT = (jid: string, sampleId: string) => `${JOURNAL_ARTICLE_SAMPLES_ENDPOINT(jid)}/${sampleId}`

export const DOCUMENTS_ENDPOINT = (projectId: string) => `${PROJECT_ENDPOINT(projectId)}/documents`
export const DOCUMENT_ENDPOINT = (projectId: string, id: string) => `${DOCUMENTS_ENDPOINT(projectId)}/${id}`
export const LINKED_ARTICLES_ENDPOINT = (projectId: string, documentId: string) => DOCUMENT_ENDPOINT(projectId, documentId) + '/articles'
export const DOCUMENT_REVISIONS_ENDPOINT = (projectId: string, documentId: string) => `${DOCUMENT_ENDPOINT(projectId, documentId)}/revisions`
export const DOCUMENT_REVISION_ENDPOINT = (projectId: string, documentId: string, revisionId: string) => `${DOCUMENT_REVISIONS_ENDPOINT(projectId, documentId)}/${revisionId}`
export const RESUBMIT_ARTICLE_ENDPOINT = (projectId: string, documentId: string) => `${DOCUMENT_ENDPOINT(projectId, documentId)}/resubmit`

export const FILES_ENDPOINT = (projectId: string) => `${PROJECT_ENDPOINT(projectId)}/files`
export const FILE_ENDPOINT = (projectId: string, id: string) => `${FILES_ENDPOINT(projectId)}/${id}`
export const FILE_PIN_ENDPOINT = (projectId: string, id: string) => `${FILE_ENDPOINT(projectId, id)}/pin`

export const ARTICLES_ENDPOINT = API_ENDPOINT('/articles')
export const ARTICLE_ENDPOINT = (id: string) => `${ARTICLES_ENDPOINT}/${id}`
export const ARTICLE_ASSIGN_ENDPOINT = (id: string) => `${ARTICLE_ENDPOINT(id)}/assign`
export const ARTICLE_DEASSIGN_ENDPOINT = (id: string) => `${ARTICLE_ENDPOINT(id)}/deassign`
export const ARTICLE_ACCEPT_REVIEW_ENDPOINT = (id: string) => `${ARTICLE_ENDPOINT(id)}/accept-review`
export const ARTICLE_ACCEPT_REVIEW_PROJECT_ENDPOINT = (id: string) => `${ARTICLE_ENDPOINT(id)}/accept-project`
export const ARTICLE_DECLINE_REVIEW_PROJECT_ENDPOINT = (id: string) => `${ARTICLE_ENDPOINT(id)}/decline-project`
export const ARTICLE_STATUS_ENDPOINT = (id: string) => `${ARTICLE_ENDPOINT(id)}/status`
export const ARTICLE_VOLUME_ENDPOINT = (id: string) => `${ARTICLE_ENDPOINT(id)}/volume`
export const ARTICLE_TEMPLATE_ENDPOINT = (id: string) => `${ARTICLE_ENDPOINT(id)}/template`
export const ARTICLE_ARCHIVE_ENDPOINT = (id: string) => `${ARTICLE_ENDPOINT(id)}/archive`
export const ARTICLE_RETRACT_ENDPOINT = (id: string) => `${ARTICLE_ENDPOINT(id)}/retract`
export const ARTICLE_COMMENT_ENDPOINT = (id: string) => `${ARTICLE_ENDPOINT(id)}/comment`
// export const ARTICLE_REVIEW_ENDPOINT = (id: string) => `${ARTICLE_ENDPOINT(id)}/review`
export const ARTICLE_TIMELINE_ENDPOINT = (id: string) => `${ARTICLE_ENDPOINT(id)}/timeline`
export const ARTICLE_ATTACHMENTS_ENDPOINT = (articleId: string) => `${ARTICLE_ENDPOINT(articleId)}/attachments`
export const ARTICLE_ATTACHMENT_ENDPOINT = (articleId: string, fileId: string) => `${ARTICLE_ATTACHMENTS_ENDPOINT(articleId)}/${fileId}`
export const ARTICLE_REVIEW_SUBMIT_ENDPOINT = (articleId: string) => `${ARTICLE_ENDPOINT(articleId)}/review`
export const ARTICLE_REVIEWS_ENDPOINT = (articleId: string) => `${ARTICLE_ENDPOINT(articleId)}/reviews`
export const ARTICLE_REVIEWERS_ENDPOINT = (articleId: string) => `${ARTICLE_ENDPOINT(articleId)}/reviewers`
export const ARTICLE_REVIEWER_ENDPOINT = (articleId: string, userId: string) => `${ARTICLE_REVIEWERS_ENDPOINT(articleId)}/${userId}`
export const ARTICLE_REVIEWER_LOCK_ENDPOINT = (articleId: string, userId: string) => `${ARTICLE_REVIEWER_ENDPOINT(articleId, userId)}/lock`
export const ARTICLE_REVIEWER_ACCEPT_ENDPOINT = (articleId: string, userId: string) => `${ARTICLE_REVIEWER_ENDPOINT(articleId, userId)}/accept`
export const ARTICLE_REVIEWER_DOCUMENT_ENDPOINT = (articleId: string, userId: string) => `${ARTICLE_REVIEWER_ENDPOINT(articleId, userId)}/review-document`
export const ARTICLE_REVIEWER_RESTORE_ENDPOINT = (articleId: string, userId: string) => `${ARTICLE_REVIEWERS_ENDPOINT(articleId)}/${userId}/restore`
export const ARTICLE_REVIEWER_REWARD_ENDPOINT = (articleId: string, userId: string) => `${ARTICLE_REVIEWERS_ENDPOINT(articleId)}/${userId}/reward`

export const ARTICLE_REVIEW_ENDPOINT = (articleId: string, reviewId: string) => `${ARTICLE_REVIEWS_ENDPOINT(articleId)}/${reviewId}`
export const START_ARTICLE_REVIEW_ENDPOINT = (articleId: string) => ARTICLE_REVIEWS_ENDPOINT(articleId)
export const SUBMIT_ARTICLE_REVIEW_ENDPOINT = (articleId: string, reviewId: string) => `${ARTICLE_REVIEW_ENDPOINT(articleId, reviewId)}`
export const ARTICLE_REVIEW_THREADS_ENDPOINT = (articleId: string, reviewId: string) => `${ARTICLE_REVIEW_ENDPOINT(articleId, reviewId)}/threads`

export const AUTH_LOGIN_ENDPOINT = API_ENDPOINT('/login')

export const THREADS_ENDPOINT = API_ENDPOINT('/threads')
export const THREAD_ENDPOINT = (id: string) => `${THREADS_ENDPOINT}/${id}`
export const THREAD_RESTORE_ENDPOINT = (id: string) => `${THREAD_ENDPOINT(id)}/restore`
export const THREAD_COMMENTS_ENDPOINT = (id: string) => `${THREAD_ENDPOINT(id)}/comments`
export const DOCUMENT_THREADS_ENDPOINT = (projectId: string, id: string) => `${DOCUMENT_ENDPOINT(projectId, id)}/threads`
export const COMMENTS_ENDPOINT = API_ENDPOINT('/comments')
export const COMMENT_ENDPOINT = (id: string) => `${COMMENTS_ENDPOINT}/${id}`

export const NOTIFICATIONS_ENDPOINT = API_ENDPOINT('/notifications/@me')

export const PROJECT_MEMBERS_ENDPOINT = (projectId: string) => `${PROJECT_ENDPOINT(projectId)}/members`
export const PROJECT_MEMBER_ENDPOINT = (projectId: string, memberId: string) => `${PROJECT_MEMBERS_ENDPOINT(projectId)}/${memberId}`

export const COURSES_ENDPOINT = API_ENDPOINT('/courses')
export const COURSE_ENDPOINT = (id: string) => `${COURSES_ENDPOINT}/${id}`
export const COURSE_VIDEO_ENDPOINT = (id: string) => `${COURSE_ENDPOINT(id)}/video`
export const COURSE_ATTACHMENTS_ENDPOINT = (id: string) => `${COURSE_ENDPOINT(id)}/attachments`
export const COURSE_ATTEND_ENDPOINT = (id: string) => `${COURSE_ENDPOINT(id)}/attend`
export const COURSE_UNATTEND_ENDPOINT = (id: string) => `${COURSE_ENDPOINT(id)}/unattend`
export const COURSES_OWNED_ENDPOINT = `${COURSES_ENDPOINT}/owned`
export const COURSES_ATTENDING_ENDPOINT = `${COURSES_ENDPOINT}/attending`
export const COURSE_INVITE_ENDPOINT = (id: string) => `${COURSE_ENDPOINT(id)}/send-invitation`
export const COURSE_VIEWER_INFO_ENDPOINT = (id: string) => `${COURSE_ENDPOINT(id)}/viewer-info`
export const COURSE_CERTIFICATE_ENDPOINT = (id: string) => `${COURSE_ENDPOINT(id)}/certificate`

export const TEMPLATES_ENDPOINT = API_ENDPOINT('/templates')
export const TEMPLATE_ENDPOINT = (id: string) => `${TEMPLATES_ENDPOINT}/${id}`

export const FORMS_ENDPOINT = API_ENDPOINT('/forms')
export const JOURNAL_FORMS_ENDPOINT = FORMS_ENDPOINT + '/journals'
export const SERVICES_FORMS_ENDPOINT = FORMS_ENDPOINT + '/services'
export const VERIFICATION_FORM_ENDPOINT = FORMS_ENDPOINT + '/verification'

export const BLOBS_ENDPOINT = API_ENDPOINT('/blobs')
export const BLOB_CONTENT_ENDPOINT = (id: string) => `${BLOBS_ENDPOINT}/${id}`

export const INTELLICHECKER_STATS_ENDPOINT = API_ENDPOINT('/stats/intellichecker')
export const INTELLICHECKER_STAT_PRESET_ENDPOINT = (preset: string) => INTELLICHECKER_STATS_ENDPOINT + '/' + preset

export const CHATS_ENDPOINT = API_ENDPOINT('/chats')
export const CHAT_ENDPOINT = (id: string) => `${CHATS_ENDPOINT}/${id}`
export const CHAT_MESSAGES_ENDPOINT = (chatId: string) => `${CHAT_ENDPOINT(chatId)}/messages`
export const CHAT_MESSAGE_ENDPOINT = (chatId: string, messageId: string) => `${CHAT_MESSAGES_ENDPOINT(chatId)}/${messageId}`
export const CHAT_MESSAGE_ATTACHMENTS_ENDPOINT = (chatId: string, messageId: string) => `${CHAT_MESSAGE_ENDPOINT(chatId, messageId)}/attachments`


export const SERVICE_REQUESTS_ENDPOINT = API_ENDPOINT('/service-requests')
export const SERVICE_REQUEST_ENDPOINT = (id: number) => `${SERVICE_REQUESTS_ENDPOINT}/${id}`
export const SERVICE_REQUEST_ATTACHMENTS_ENDPOINT = (id: number) => `${SERVICE_REQUEST_ENDPOINT(id)}/attachments`
export const SERVICE_REQUEST_EXPERTS_CHATS_ENDPOINT = (id: number) => `${SERVICE_REQUEST_ENDPOINT(id)}/expert-chat`

export const INTELLICHECKER_ENDPOINT = API_ENDPOINT('/intellichecker')
export const INTELLICHECKER_PRESET_ENDPOINT = (preset: string) => `${INTELLICHECKER_ENDPOINT}/${preset}`

export const QUIZZES_ENDPOINT = API_ENDPOINT('/quizzes')
export const QUIZZES_OWNED_ENDPOINT = (userId: string) => `${QUIZZES_ENDPOINT}/owned/${userId}`
export const QUIZ_ENDPOINT = (quizId: string) => `${QUIZZES_ENDPOINT}/${quizId}`
export const QUIZ_ANSWERS_ENDPOINT = (quizId: string) => `${QUIZ_ENDPOINT(quizId)}/answers`
export const QUIZ_SUBMISSIONS_ENDPOINT = (quizId: string) => `${QUIZ_ENDPOINT(quizId)}/submissions`
export const QUIZ_VERSIONS_ENDPOINT = (quizId: string) => `${QUIZ_ENDPOINT(quizId)}/versions`

export const PAYMENTS_ENDPOINT = API_ENDPOINT('/payments')
export const PAYMENTS_IC_COUNTER_ENDPOINT = `${PAYMENTS_ENDPOINT}/ic-counter`
